// Customizable Area Start
import React from "react";
import LiveStreamingController, { Props } from "./LiveStreamingController.web";
import {
  Box,
  createStyles,
  withStyles,
  ThemeProvider,
} from "@material-ui/core";
import lightTheme from "../../../components/src/lightTheme";
import darkTheme from "../../../components/src/darkTheme";
import Livestream from "../../../components/src/Livestream";
import Loader from "../../../components/src/Loader";

export class LiveStreaming extends LiveStreamingController {
  constructor(props: Props) {
    super(props);
  }

  handleGoBackHome = () => {
    if (this.state.storyId && this.state.isHost) {
      this.updateEndLiveStory(this.state.storyId);
    }
    this.props.navigation.navigate("ActivityFeed");
  };

  render() {
    const { classes, checked } = this.props;
    const {
      isLoading,
      loggedUser,
      livestreamToken,
      channelName,
      uid,
      chatRoomId,
      chatToken,
      userChatName,
      isHost,
      ownerId,
    } = this.state;
    const theme = checked ? lightTheme : darkTheme;

    return (
      <ThemeProvider theme={theme}>
        <Box className={classes.container}>
          <Loader loading={isLoading} />
          {channelName &&
            livestreamToken &&
            uid &&
            chatToken &&
            userChatName &&
            loggedUser && (
              <Livestream
                channelName={channelName}
                uid={uid}
                userId={userChatName}
                livestreamToken={livestreamToken}
                roomId={chatRoomId}
                chatToken={chatToken}
                ownerId={ownerId}
                onGoHome={this.handleGoBackHome}
                isHost={isHost}
                loggedUser={loggedUser}
              />
            )}
        </Box>
      </ThemeProvider>
    );
  }
}

const styles = createStyles({
  container: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    background: "#070707",
  },
});

export default withStyles(styles)(LiveStreaming);

// Customizable Area End
